import getResource from '../resources';


export default {
    methods: {
        resource(name){
            return getResource(name);
        }
    }
};